import { Component, Input, OnInit, EventEmitter, Output, OnChanges } from '@angular/core';
import { AttachmentService } from '../Services/Attachment.Service';
import { Attachment } from '../models/Attachment';
import { firstValueFrom } from 'rxjs';
@Component({
    selector: 'app-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.css'],
    standalone: false
})
export class AttachmentComponent implements OnInit, OnChanges {

  Attachments : Attachment[] = [];
  @Input() InputKaizenID?: number;
  @Output() emitKaizenAttachment: EventEmitter<Attachment[]> = new EventEmitter<Attachment[]>();

  kaizenID: number = 0;
  maxFileSize: number = 6291456  //This is 6MB since 1,048,576 is 1MB 
  supportedUploadFileTypes = [
    'xls', 'xlsm', 'xlsx',
    'doc', 'docm', 'docx',
    'txt',
    'png', 'jpg', 'gif', 'jpeg',
    'pdf',
    'ppt', 'pptx', 'pptm'

  ];
  extension: string = '';
  errorFileTypeNotSupported: boolean = false;
  errorFileTooLarge: boolean = false;
  errorFileLimit: boolean = false;
  fileSelectionBoxLabel: string = "Choose file...";
  errorMessage: string = '';
  constructor(private AttachmentService: AttachmentService) { }

  ngOnInit(): void {
  }

  ngOnChanges() 
  {
    
    this.kaizenID = this.InputKaizenID??0;
    if(this.kaizenID > 0)
    {
      firstValueFrom(this.AttachmentService.getAttachmentsByKaizenId(this.kaizenID)).then((data) => {
        this.Attachments = data?.data || [] ;
      })
    }

  }
  fileUploadChanged(event: any) {
    var file = event.target.files[0];
    this.fileSelectionBoxLabel = file.name;

    if (file.size > this.maxFileSize) {
      this.errorFileTooLarge = true;
      this.errorMessage = '** File size must be less than 6MB';
    }

    //This the extension.  If no extension exists then empty string is returned
    var uploadFileExtension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);

    if (!this.supportedUploadFileTypes.includes(uploadFileExtension)) {
      this.extension = uploadFileExtension;
      this.errorFileTypeNotSupported = true;
      this.errorMessage = '** File type ' + this.extension + ' is not supported';
    }

    if (this.Attachments.length > 4) {
      this.errorFileLimit = true;
      this.errorMessage = '** Only 5 attachments are allowed';
    }

    if (!this.errorFileTooLarge &&
      !this.errorFileTypeNotSupported &&
      !this.errorFileLimit
    ) {
      this.AttachmentService.uploadFile(file, this.kaizenID).subscribe({
        next: data => { this.addAttachment(file.name) },
        error: error => { console.log('There was an error!', error); }
      });
      this.errorMessage = '';
    }
    else {
      this.errorFileTooLarge = false;
      this.errorFileTypeNotSupported = false;
      this.errorFileLimit = false;
    }


  }

  addAttachment(fileName: string) {
    let newAttachment: Attachment =
    {
      kaizenID: this.kaizenID,
      kaizenAttachmentID: 0,
      attachmentName: fileName,
      attachementPath: '',
      attachmentComments: '',
      isActive: ''
    }
    this.AttachmentService.addAttachment(newAttachment).subscribe({
      next: data => {
        newAttachment.kaizenAttachmentID = data.data;
        this.Attachments.push(newAttachment);
        this.fileSelectionBoxLabel = "Choose file...";
      },
      error: error => { console.log('There was an error!', error); }
    });
  }

  downloadAttachment(attachmentName: string, kaizenId: number) {
    this.AttachmentService.viewFile(attachmentName, kaizenId).subscribe({
      next: results => {
        window.open(results, '_blank');
      },
      error: error => { console.log('There was an error!', error); }
    });
  }

  DeleteAttachment(attachmentId: number, attachmentName: string) {
    this.AttachmentService.deleteAttachment(attachmentId).subscribe({
      next: data => {

        this.AttachmentService.deleteFile(this.kaizenID, attachmentName).subscribe({
          next: blobData => { },
          error: error => { console.log('There was an error!', error); }
        })

        //remove the deleted attachment from the array to remove it from the display also
        this.Attachments.splice(this.Attachments.findIndex(a => a.kaizenAttachmentID == attachmentId), 1);

      },
      error: error => { console.log('There was an error!', error); }
    });
  }



}
